module.exports = __webpack_public_path__ + "img/wxxcx.62f2c0fc.jpg";